var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "125%",
    height: "700%",
    x: "-12.5%",
    y: "-300%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 3.24
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2E5335",
    opacity: 0.539,
    style: {
      mixBlendMode: "soft-light"
    },
    cx: 133.44,
    cy: 210.24,
    rx: 46.44,
    ry: 3.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2E5335",
    opacity: 0.269,
    style: {
      mixBlendMode: "multiply"
    },
    cx: 133.44,
    cy: 211.32,
    filter: "url(#prefix__a)",
    rx: 38.88,
    ry: 1.62
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M173.501 142.691c9.047 0 16.409-7.36 16.409-16.407s-7.362-16.407-16.409-16.407c-9.045 0-16.407 7.36-16.407 16.407s7.362 16.407 16.407 16.407M95.008 142.691c9.045 0 16.407-7.36 16.407-16.407s-7.362-16.407-16.407-16.407c-9.047 0-16.409 7.36-16.409 16.407s7.362 16.407 16.409 16.407M134.191 140.522c11.414 0 20.7-9.286 20.7-20.7s-9.286-20.7-20.7-20.7-20.7 9.286-20.7 20.7 9.286 20.7 20.7 20.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M94.6 66.2H62.2c-3.97 0-7.2 3.23-7.2 7.2v16.2c0 3.97 3.23 7.2 7.2 7.2h8.76l4.353 7.252c.652 1.087 1.827 1.748 3.087 1.748.056 0 .113-.002.173-.004 1.325-.064 2.507-.851 3.078-2.05l3.306-6.946H94.6c3.97 0 7.2-3.23 7.2-7.2V73.4c0-3.97-3.23-7.2-7.2-7.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#36947D",
    stroke: "#31957D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.678 30.802l8.736.44c1.24.061 2.236 1.082 2.212 2.28-.024 1.2-1.06 2.127-2.3 2.065l-8.74-.428c-1.24-.061-2.232-1.094-2.208-2.292.025-1.198 1.06-2.126 2.3-2.065zM10.445 9.09l6.166 6.03c.871.85.895 2.223.06 3.04-.842.83-2.246.8-3.116-.05l-6.166-6.03c-.871-.85-.895-2.222-.06-3.04.842-.83 2.246-.8 3.116.05zM31.74 3.586l.082 8.558c.006 1.216-.964 2.275-2.167 2.344-1.194.077-2.182-.864-2.198-2.07l-.073-8.568c-.015-1.207.955-2.265 2.159-2.334 1.193-.077 2.19.853 2.197 2.07z",
    transform: "rotate(16 -89.019 157.961)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#91D9BF",
    d: "M116.2 32c-3.97 0-7.2 3.23-7.2 7.2V77c0 3.97 3.23 7.2 7.2 7.2h30.028l4.464 10.418c.538 1.255 1.738 2.097 3.103 2.177.068.003.137.005.205.005 1.287 0 2.482-.688 3.125-1.814L163.29 84.2h15.91c3.97 0 7.2-3.23 7.2-7.2V39.2c0-3.97-3.23-7.2-7.2-7.2h-63z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127 50L166.6 50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M166.6 53.6H127c-1.987 0-3.6-1.613-3.6-3.6s1.613-3.6 3.6-3.6h39.6c1.987 0 3.6 1.613 3.6 3.6s-1.613 3.6-3.6 3.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M127 64.4L152.2 64.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M152.2 68H127c-1.987 0-3.6-1.613-3.6-3.6s1.613-3.6 3.6-3.6h25.2c1.987 0 3.6 1.613 3.6 3.6s-1.613 3.6-3.6 3.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0,
    d: "M0 0H260V260H0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M116.461 144.72h-.016C104.976 145.56 96 155.23 96 166.735v9.148c0 2.848 2.317 5.164 5.165 5.164h65.671c2.848 0 5.164-2.316 5.164-5.164v-9.148c0-11.506-8.976-21.176-20.436-22.016-.041-.004-.12.024-.15.053l-.004.004c-4.689 4.56-10.872 7.071-17.41 7.071s-12.721-2.51-17.41-7.07c-.05-.05-.096-.059-.129-.059M91.286 175.884v-9.148c0-6.522 2.355-12.56 6.272-17.274-.808.112-1.626.19-2.455.19-4.664 0-9.074-1.792-12.42-5.044-.437-.425-1.031-.649-1.649-.602C70.922 144.746 63 153.28 63 163.434v7.25c0 3.35 2.724 6.075 6.076 6.075H91.33c-.024-.289-.044-.58-.044-.875M187.663 144.006c-.604-.038-1.211.177-1.648.602-3.343 3.252-7.757 5.043-12.419 5.043-.88 0-1.746-.084-2.604-.21 3.932 4.716 6.294 10.763 6.294 17.294v9.15c0 .294-.019.585-.044.874h22.383c3.348 0 6.074-2.726 6.074-6.075v-7.25c0-10.156-7.924-18.689-18.036-19.428"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.41efbaab15158c42ddbae59332f2b28e.svg";
export { ForwardRef as ReactComponent };